import React from "react";
interface IItemMainMenuProps {
  name: string;
}

export function ItemMainMenu(props: IItemMainMenuProps): JSX.Element {
  return (
    <div className="rowMenuItem">
      <a href="/" className="menuItem">
        {props.name}
      </a>
    </div>
  );
}
